// Sprint-003 A6 — a stable, deterministic color per person for the Team
// tab / hand-out-work UI (avatar initials, assignee-picker rows). Mirrors
// the mock's four hand-picked person colors (deliverables/mock-today-
// card-2026-07-06.html's `HELPERS` array); cycled by a hash of the
// person's id rather than list position, so the same person always gets
// the same color across renders/reloads regardless of roster ordering.
const PALETTE = ["var(--pine)", "var(--amber-deep)", "var(--clay)", "var(--moss)"] as const;

export function colorForPerson(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i += 1) {
    hash = (hash * 31 + userId.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length] as string;
}

export function firstName(fullName: string | null): string {
  if (!fullName) return "";
  return fullName.split(" ")[0] ?? fullName;
}
